import { useRef, useState } from 'react';
import './MobileAccordionGroup.scss';
import SingleAccordion from './MobileSignleAccordion';

interface AccordionChild {
  title: React.ReactNode;
  content: React.ReactNode;
}

interface Props {
  accordionList: Array<AccordionChild>;

  className?: string;
}

const MobileAccordionGroup = ({ accordionList, className }: Props) => {
  const [selectedAccordion, setSelectedAccordion] = useState<string>('');

  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className={`ui-accordion mt-25 ${className}`}>
      {accordionList.map(({ title, content }, index) => {
        return (
          <SingleAccordion
            containerRef={containerRef}
            accordionKey={index.toString()}
            title={title}
            content={content}
            selectedAccordionKey={selectedAccordion}
            setSelectedAccordionKey={setSelectedAccordion}
          />
        );
      })}
    </div>
  );
};

export default MobileAccordionGroup;
